import { render, staticRenderFns } from "./ContraloriaSocial.vue?vue&type=template&id=c4351a4e&"
import script from "./ContraloriaSocial.vue?vue&type=script&lang=js&"
export * from "./ContraloriaSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports